import { SkeletonCircle } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import GradientBackground from '../Common/Background/GradientBackground';

export const RechargeSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-autotext select-none shadow-lg rounded-2xl backdrop-blur-sm">
      <GradientBackground vertical color1='#000' color2='#878B8B' className="px-8 pb-10 rounded-2xl text-center flex flex-col gap-2 items-center" noCenter>
        <div className="relative flex justify-center pt-14 py-6">
          <h1 className="font-bold tracking-tight text-primary text-2xl md:text-4xl text-center max-w-[200px] md:max-w-[300px]">
            {t('recharge.heading')}
          </h1>
        </div>

        <SkeletonCircle w={40} h={14} />

        <div className="flex flex-col gap-1 w-full">
          <div className="text-primary font-medium text-center mt-2 mb-0 md:mt-4 md:mb-2">
            {t('recharge.mobileNumber')}
          </div>
          <SkeletonCircle w='full' h={9} />
        </div>

        <div className="flex flex-col gap-1 w-full">
          <div className="text-primary font-medium text-center mt-2 mb-0 md:mt-4 md:mb-2">
            {t('recharge.selectCurrency')}
          </div>
          <SkeletonCircle w='full' h={9} />
        </div>

        <div className="flex flex-col gap-1 w-full">
          <SkeletonCircle w='full' h={9} />
        </div>

        <SkeletonCircle w={40} h={12} mt={8} />
      </GradientBackground>
    </div>
  );
};

export default RechargeSkeleton;
